export const CLICK_TO_SUBSCRIBER_PAGE_EVENT = 'Click Into Subscribe Page'
export const CLICK_SUBSCRIPTION_ACCOUNT_MENU_EVENT =
  'Click Subscription From Account Menu'
export const CLICK_ACCOUNT_MENU_EVENT = 'Click Account Menu'
export const CLICK_HELP_ACCOUNT_MENU_EVENT = 'Click Help From Account Menu'
export const CLICK_REQUEST_FEATURE_ACCOUNT_MENU_EVENT =
  'Click Request a Feature From Account Menu'
export const CLICK_SUGGEST_TITLE_MENU_EVENT =
  'Click Suggest Title From Account Menu'
export const CLICK_AUTHOR_GENRE_MENU_EVENT =
  'Click Author & Genre From Account Menu'
export const CLICK_LEARNING_RESOURCES_MENU_EVENT =
  'Click Learning Resources From Account Menu'
export const CLICK_SAVED_GUIDES_MENU_EVENT =
  'Click Saved Guides From Account Menu'
export const CLICK_COLLECTIONS_MENU_EVENT =
  'Click Collections From Account Menu'
export const CLICK_HOME_MENU_EVENT = 'Click Home From Account Menu'
export const CLICK_MOBILE_APP_MENU_EVENT = 'Click Mobile App From Account Menu'
export const CLICK_SEARCH_BAR = 'Clicked Search Bar'
export const CLICK_FILTER_GUIDE_LIBRARY = 'guide_library_filter_clicked'
export const CLICK_MANY_MORE_GUIDE_LIBRARY = 'guide_library_many_more_clicked'
export const CLICK_SEE_ALL_CURATED_COLLECTIONS =
  'curated_collections_see_all_clicked'
export const CLICK_TRIAL_SUBSCRIBE_PAGE = 'subscribe_page_trial_clicked'
export const CLICK_PLANS_SUBSCRIBE_PAGE = 'subscribe_page_view_plans_clicked'
export const CLICK_EXAMPLE_SUBSCRIBE_PAGE = 'subscribe_page_example_clicked'
export const CLICK_EXAMPLE_SECTION_SUBSCRIBE_PAGE =
  'subscribe_page_example_section_clicked'
export const CLICK_PLAN_SUBSCRIBE_PAGE = 'subscribe_page_pricing_plan_clicked'
export const CLICK_FAQ_ITEM = 'faq_item_clicked'
export const CLICK_USE_CASE_FOOTER_ITEM = 'use_cases_footer_item_clicked'
export const SELECT_DIFFERENT_AUDIENCE =
  'subscribe_page_different_audience_selected'
export const MODAL_OPENED_EVENT = 'Modal Opened'
export const CLICK_SUGGEST_TITLE_BUTTON_EVENT = 'Click Into Suggest a Title'

// Free Trial
export const FREE_TRIAL_UPGRADE_INTENDED = 'Free Trial Upgrade Intended'

// Group Subscription
export const GROUP_SUBSCRIPTION_INTENDED = 'Group Subscription Intended'

// Suggest Title
export const CLICK_SUGGEST_TITLE_CTA = 'SuggestTitleCTA'
export const TITLE_SUGGESTED = 'Title Suggested'
export const SUGGEST_A_TITLE = 'Suggest a Title'

// Checkout
export const CHECKOUT_PAYMENT_STARTED = 'Checkout - Payment Started'
export const CHECKOUT_CREATE_ACCOUNT_STARTED =
  'Checkout - Create Account Started'

export const LEGACY_SEARCH_CLICKED = 'Legacy Search Clicked'

// Freemium
export const CLICK_FREEMIUM_UPGRADE_CTA = 'Upgrade CTA Clicked'
